import { Navigate, NavLink, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';

import WelcomeHero from './welcome_hero.svg';
import SecurityShield from './security_shield.svg';
import Icon from '../../components/Icon';
import { hasSeenWelcome } from '../../lib/ab-tests/hasSeenWelcome';
import { afterWelcomePath } from './afterWelcomePath';

import './styles.scss';

export default function WelcomeView() {
  const { search } = useLocation();
  const { t } = useTranslation();

  if (hasSeenWelcome({ search }))
    return <Navigate to={afterWelcomePath(search)} />;

  return (
    <div className="welcome-view">
      <main className="welcome-view-content">
        <h1>{t('welcomeView.title')}</h1>
        <p className="copy subheading">{t('welcomeView.subheading')}</p>
        <img src={WelcomeHero} />
        <h2>{t('welcomeView.details.heading')}</h2>
        <div className="section detail">
          <Icon icon="scope-transactions-read" />
          <h3>{t('welcomeView.details.linkHeading')}</h3>
          <p className="copy">{t('welcomeView.details.linkCopy')}</p>
        </div>
        <div className="section detail">
          <Icon icon="institution-credit-card" />
          <h3>{t('welcomeView.details.fetchBalancesHeading')}</h3>
          <p className="copy">{t('welcomeView.details.fetchBalancesCopy')}</p>
        </div>
        <div className="section detail">
          <Icon icon="income-amount" />
          <h3>{t('welcomeView.details.latestHeading')}</h3>
          <p className="copy">{t('welcomeView.details.latestCopy')}</p>
        </div>
        <div className="section security">
          <h3>
            <img className="icon" src={SecurityShield} />
            {t('welcomeView.securityHeading')}
          </h3>
          <p className="copy">{t('welcomeView.securityCopy')}</p>
        </div>
        <NavLink to={afterWelcomePath(search)}>
          {t('welcomeView.dismissLink')}
        </NavLink>
      </main>
    </div>
  );
}
